module.exports = __webpack_public_path__ + "media/images/emoticons/restaurant-d32fd42c1e250448beaa840b832062f6.gif";